import { useMutation, useQuery } from '@tanstack/react-query'
import {
  getBillingRuns,
  getFeeCalcTypes,
  getFeeMethods,
  getFeeSchedules,
  getBillingSystemConfig,
  postNamedQuery,
  putClientBillingInfo
} from '../service'
import { useAppContext } from '../redux/slices/appContext'
import { QUERY_KEYS } from './queryKeys'

export const useFeeCalcTypes = (mapper = null) => {
  const { userId } = useAppContext()
  return useQuery({
    queryKey: [QUERY_KEYS.feeCalcTypes, userId],
    queryFn: async () => {
      const { data } = await getFeeCalcTypes()
      return mapper ? mapper(data) : data
    }
  })
}

export const useFeeMethods = (mapper = null) => {
  const { userId } = useAppContext()
  return useQuery({
    queryKey: [QUERY_KEYS.feeMethods, userId],
    queryFn: async () => {
      const { data } = await getFeeMethods()
      return mapper ? mapper(data) : data
    }
  })
}

export const useFeeSchedule = (mapper = null) => {
  const { userId } = useAppContext()
  return useQuery({
    queryKey: [QUERY_KEYS.feeSchedule, userId],
    queryFn: async () => {
      const { data } = await getFeeSchedules()
      return mapper ? mapper(data) : data
    }
  })
}

export const useBillingRuns = (query = {}, options = {}) => {
  const { userId } = useAppContext()
  const { mapper = null } = options
  return useQuery({
    ...options,
    queryKey: [QUERY_KEYS.billingRuns, userId],
    queryFn: async () => {
      const { data } = await getBillingRuns(query)
      return mapper ? mapper(data) : data
    }
  })
}

export const useFeatureScheduleExposure = (query = {}, options = {}) => {
  const { searchForMultiple, mapper } = options
  const key = searchForMultiple ? QUERY_KEYS.feeScheduleMultipleExposures : QUERY_KEYS.feeScheduleNoExposure
  const { userId } = useAppContext()
  return useQuery({
    queryKey: [key, userId, query],
    queryFn: async () => {
      const { data } = await postNamedQuery(
        'billing',
        'feeSchedulesExposure',
        query
      )
      return data
    },
    select: mapper
  })
}

export const useBillingSystemConfig = () => {
  const { userId } = useAppContext()
  return useQuery({
    queryKey: [QUERY_KEYS.billingSystemConfig, userId],
    queryFn: async () => {
      const { data } = await getBillingSystemConfig()
      return data
    }
  })
}

export const useSaveClientBillingInfoMutation = () => {
  return useMutation({
    mutationFn: async ({ clientId, billingInfo }) => {
      const { data } = await putClientBillingInfo(clientId, billingInfo)

      return data
    }
  })
}
